
import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import ObservationMixin from '@/_mixins/observation'

import DialogTemplate from '@/_components/dialog/template/template.vue'

@Component({
    inheritAttrs: false,
    name: 'PublishDialog',
    mixins: [ObservationMixin],
    components: { DialogTemplate },
})
export default class PublishDialog extends Mixins<MixinInterface>(ObservationMixin) {
    @Prop() props!: any

    get observation() {
        return this.props.observation
    }

    get handleObservation() {
        return this.props.handleObservation
    }

    get handlePatchObservation() {
        return this.props.handlePatchObservation
    }

    get handlePostObservation() {
        return this.props.handlePostObservation
    }

    publishObservationDialog = false
    publishObservationLoading = false
    publishObservationError = false

    async publishObservation(anonymous?: boolean) {
        try {
            this.publishObservationLoading = true
            let observationId = this.observation?.id == '0' ? null : this.observation?.id

            if (this.handleObservation) {
                if (observationId) {
                    await this.handlePatchObservation()
                } else {
                    let newObservation = await this.handlePostObservation()
                    observationId = newObservation.id
                }
            }

            await this.publishPrivateObservation(observationId, anonymous)
            this.publishObservationDialog = false
            this.$emit('close', true)
        } catch (error) {
            this.publishObservationError = true
        } finally {
            this.publishObservationLoading = false
        }
    }
}
